var map = {
	"./60minutes.jpg": 300,
	"./electricrevolution.jpg": 301,
	"./hiddenmagnets.jpg": 302,
	"./newelectricbike.jpg": 303,
	"./technology_doping.jpg": 304,
	"./theengine.jpg": 305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 299;